/**
 * Returns a validation function that returns true if at least n of
 * the given list of validationFns pass.
 *
 * n must be less than or equal to the length of validationFns.
 *
 * @param {number} n
 * @param {((value: string) => boolean)[]} validationFns
 * @returns {(value: string) => boolean}
 */
export function meetsAtLeastN(n, validationFns) {
    return function (value) {
        let met = 0;

        for (const validate of validationFns) {
            if (validate(value)) {
                met++;
            }

            if (met >= n) {
                return true;
            }
        }

        return false;
    };
}

/**
 * Returns a validation function that returns true if the input
 * value matches the given regex pattern.
 *
 * @param {RegExp} pattern
 * @returns {(value: string) => boolean}
 */
export function matchesPattern(pattern) {
    return function (value) {
        return pattern.test(value);
    };
}
